<template>
  <div class="wc-news-detail">
    <div class="wc-news-detail__bar">
      <button @click="backToNews" aria-label="返回"></button>
      <span>资讯详情</span>
    </div>
    <load-state :state="state" empty-text="资讯不存在或已下架" @retry="load(false)">
      <article class="wc-news-detail__article">
        <h1>{{ detail.title }}</h1>
        <div class="wc-news-detail__meta">
          <span>{{ detail.news_source }}</span>
          <em>{{ detailTime(detail.publish_time) }}</em>
        </div>
        <img v-if="detailImage(detail.img) && !imageFailed" class="wc-news-detail__cover" :src="detailImage(detail.img)" :alt="detail.title" @error="imageFailed = true">
        <div class="wc-news-detail__content" v-html="content"></div>
      </article>
    </load-state>
  </div>
</template>

<script>
import { getNewsInfo } from '@/api/worldcup2026'
import LoadState from '../components/LoadState.vue'
import { worldcupCache } from '../utils/cache'
import { sanitizeNewsHtml } from '../utils/sanitize'
import { formatNewsDetailTime } from '../utils/time'
import { normalizeImageUrl } from '../utils/image'

export default {
  name: 'WorldCupNewsDetail',
  components: { LoadState },
  data () {
    return {
      state: 'idle',
      detail: {},
      imageFailed: false
    }
  },
  computed: {
    newsId () {
      return this.$route.params.newsId
    },
    content () {
      return sanitizeNewsHtml(this.detail.content || '')
    }
  },
  created () {
    this.load(true)
  },
  methods: {
    backToNews () {
      const query = this.$route.query.screen ? { screen: this.$route.query.screen } : {}
      this.$router.push({ path: '/worldcup2026/news', query })
    },
    detailImage (url) {
      return normalizeImageUrl(url)
    },
    detailTime (value) {
      return formatNewsDetailTime(value)
    },
    async load (useCache) {
      if (useCache && worldcupCache.newsDetails[this.newsId]) {
        this.applyDetail(worldcupCache.newsDetails[this.newsId])
        return
      }
      this.state = 'loading'
      try {
        const resp = await getNewsInfo({ id: this.newsId })
        if (resp.error_code !== 0) {
          this.state = 'error'
          return
        }
        const detail = resp.result && resp.result.data ? resp.result.data : null
        if (detail) worldcupCache.newsDetails[this.newsId] = detail
        this.applyDetail(detail)
      } catch (e) {
        this.state = 'error'
      }
    },
    applyDetail (detail) {
      this.detail = detail || {}
      this.state = detail ? 'success' : 'empty'
    }
  }
}
</script>

<style scoped lang="scss">
.wc-news-detail {
  min-height: 100%;
  background: #f4f5f7;
}

.wc-news-detail__bar {
  position: sticky;
  top: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: calc(48px + var(--wc-status-top, 0px));
  padding: var(--wc-status-top, 0px) 16px 0;
  background: #ffffff;
  border-bottom: 1px solid #edf0f3;
}

.wc-news-detail__bar button {
  position: relative;
  width: 30px;
  height: 30px;
  border: 0;
  background: transparent;
}

.wc-news-detail__bar button::before {
  content: '';
  position: absolute;
  left: 9px;
  top: 9px;
  width: 10px;
  height: 10px;
  border-left: 2px solid #1a1a1a;
  border-bottom: 2px solid #1a1a1a;
  transform: rotate(45deg);
}

.wc-news-detail__bar span {
  flex: 1;
  margin-right: 30px;
  text-align: center;
  color: #1a1a1a;
  font-size: 16px;
  font-weight: 700;
}

.wc-news-detail__article {
  margin: 12px;
  padding: 16px;
  border-radius: 8px;
  background: #ffffff;
}

.wc-news-detail__article h1 {
  margin: 0;
  color: #1a1a1a;
  font-size: 20px;
  line-height: 28px;
}

.wc-news-detail__meta {
  display: flex;
  align-items: center;
  margin-top: 10px;
  color: #9aa0a6;
  font-size: 12px;
}

.wc-news-detail__meta span {
  padding: 2px 6px;
  border-radius: 10px;
  color: #b07d00;
  background: #fff7df;
}

.wc-news-detail__meta em {
  margin-left: 8px;
  font-style: normal;
}

.wc-news-detail__cover {
  display: block;
  width: 100%;
  margin-top: 14px;
  border-radius: 8px;
}

.wc-news-detail__content {
  margin-top: 14px;
  color: #1a1a1a;
  font-size: 15px;
  line-height: 24px;
  word-break: break-word;
}

.wc-news-detail__content {
  ::v-deep img {
    max-width: 100%;
    height: auto;
  }

  ::v-deep a {
    color: inherit;
    text-decoration: none;
    pointer-events: none;
  }
}
</style>
